module.exports = __webpack_public_path__ + "img/imge4.3b8cf6ec.png";